const validationsConfig = {
    proveedor: {
        required: true,
        validate: { isNull: (value) => (value === 'null' ? false : true) },
        nameForMessage: 'Proveedor',
    },
}

export default validationsConfig
